<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title=" Select Workstation"
      ref="workStationSettingModal"
      id="workStationSettingModal"
      size="sm"
      @shown="loadWorkstation"
    >
      <div class="row settings-box">
        <div class="col-12 py-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container w-100">
              <label :class="selectedWorkstation ? 'shift-up' : ''">
                Workstation Type
              </label>
              <multiselect
                v-model="selectedWorkstation"
                :options="workstationOptions"
                :searchable="false"
                :multiple="false"
                :allow-empty="false"
                placeholder="."
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 pt-3 text-center">
          <button
            class="btn-blue"
            :disabled="!selectedWorkstation || isSaving"
            @click="saveWorkstation"
          >
            Save
          </button>
          <button
            @click.prevent.stop="$bvModal.hide('workStationSettingModal')"
            class="btn-blue"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  getWorkstation,
  saveWorkstation as saveWorkstationSetting
} from "@/util/indexDb/workstationIndexDb";

export default {
  data() {
    return {
      isSaving: false,
      selectedWorkstation: "",
      workstationOptions: ["BO", "FNB", "BOFNB"]
    };
  },
  mounted() {
    this.loadWorkstation();
  },
  methods: {
    async loadWorkstation() {
      try {
        const value = await getWorkstation();
        // console.log("Loaded workstation from IndexedDB:", value);
        if (this.workstationOptions.includes(value)) {
          this.selectedWorkstation = value;
        }
      } catch (error) {
        console.log("Unable to load workstation from IndexedDB", error);
      }
    },
    async saveWorkstation() {
      if (!this.selectedWorkstation) {
        this.$toasted.show("Please select workstation.");
        return;
      }

      try {
        this.isSaving = true;
        await saveWorkstationSetting(this.selectedWorkstation);

        this.$toasted.show("Workstation saved successfully.");
        this.$bvModal.hide("workStationSettingModal");
      } catch (error) {
        console.log("Unable to save workstation in IndexedDB", error);
        this.$toasted.show("Unable to save workstation.");
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style>
.settings-box {
  font-size: 12px;
  font-weight: bold;
}

#workStationSettingModal___BV_modal_content_ {
  width: 135% !important;
  margin: auto;
}
#workStationSettingModal___BV_modal_title_ {
  width: 100%;
  text-align: center;
  color: var(--blue);
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/WorkstationPopup.vue